import React, { Component } from "react";
import "./Footer.css";
import { ReactComponent as Logo } from "../../loghi/farmakom.svg";

class Footer extends Component {
  render() {
    return (
      <footer className="main-footer">
        <span>© Farmakom Srl</span>
        <Logo />
      </footer>
    );
  }
}

export default Footer;
